namespace Customer
{

	export class Page
		extends ui.tab.TabHTMLPresentation
	{

		private m_Customer: Wollmilch.Customer|null;

		constructor( contractor: Wollmilch.CompanyObject, customer: number|Wollmilch.CustomerObject )
		{
			super();

			this.m_Root.addClass( 'container-fluid' );

			this.m_Customer = null;

			if ( typeof customer === 'number' )
			{
				new Wollmilch.AJAX(
					{
						url: 'organization/show/' + customer,
						async: false,
						on:
						{
							success: ( text: string ): void =>
							{
								const obj = Wollmilch.jsonize( text );

								if ( obj && obj.success )
								{
									this.m_Customer = new Wollmilch.Customer( contractor, obj.data );
								}
							}
						}
					}
				).send();
			}
			else
			{
				this.m_Customer	= new Wollmilch.Customer( contractor, customer );
			}

			this.Display();
		}

		public Display(): void
		{
			this.m_Root.empty();

			const left = ui.$$.div().addClass( 'col-xs-12' ).addClass( 'col-sm-6' );
			const right = ui.$$.div().addClass( 'col-xs-12' ).addClass( 'col-sm-6' );

			this.m_Root.append( ui.$$.div().addClass( 'row' ).append( left ).append( right ) );

			if ( this.m_Customer )
			{
				//@ts-ignore
				SPA.Customer.gui.Factory.createBuilder( SPA.types.BuilderFactoryType.customer, this.m_Customer.Customer() ).rebuild( left );
				//@ts-ignore
				SPA.Customer.gui.Factory.createBuilder( SPA.types.BuilderFactoryType.customer, this.m_Customer.Contractor() ).rebuild( right );
			}
		}

		public Root(): JQuery<HTMLElement>
		{
			return this.m_Root;
		}

	}

}
